import React from 'react'
import asideModalStore from 'Stores/asideModalStore'
import st from './AddCertificatesModal.module.scss'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import FormInput from 'components/UI/AsideModal/Form/FormInput'
import { observer } from 'mobx-react'

const AddCertificatesModal = ({ translate }) => {
  const { modalValues: modalValue, changeValue, check } = asideModalStore

  return (
    <div className={st.fieldSet}>
      <FormField>
        <FormLabel isRequired>{translate.certificate_name}:</FormLabel>
        <FormInput isError={check('name')}>
          <input
            type='text'
            placeholder={translate.certificate_name}
            name='name'
            value={modalValue?.name || ''}
            onChange={(e) => changeValue(e.target.value, 'name')}
          />
        </FormInput>
      </FormField>
      <FormField>
        <FormLabel isRequired>{translate.valid_for_days}:</FormLabel>
        <FormInput isError={check('days_active')}>
          <input
            type='number'
            placeholder={translate.valid_for_days}
            name='days_active'
            value={modalValue?.days_active || ''}
            onChange={(e) => changeValue(e.target.value, 'days_active')}
          />
        </FormInput>
      </FormField>
      <FormField>
        <FormLabel isRequired>{translate.certificate_amount}:</FormLabel>
        <FormInput isError={check('amount')}>
          <input
            type='number'
            placeholder={translate.certificate_amount}
            name='amount'
            value={modalValue?.amount || ''}
            onChange={(e) => changeValue(e.target.value, 'amount')}
          />
        </FormInput>
      </FormField>
    </div>
  )
}

export default observer(AddCertificatesModal)
